import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: "#1",
  title: 'GUÍA “¿QUÉ HAGO CUANDO TENGO UNA CRISIS EMOCIONAL?”',
  desc: "Una guía práctica para esos momentos donde aparecen tristeza, ansiedad, pensamientos repetitivos, impulsos o ganas de volver a patrones anteriores."
}, {
  num: "#2",
  title: "7 DÍAS PARA VOLVER A TI",
  desc: "7 meditaciones/guías de práctica para acompañar los primeros días del proceso."
}, {
  num: "#3",
  title: "CUADERNO DE RECONSTRUCCIÓN",
  desc: "Workbook digital con ejercicios para reflexionar, ordenar emociones y tomar nuevas decisiones."
}, {
  num: "#4",
  title: "MAPA DE RECONSTRUCCIÓN PERSONAL",
  desc: "Una herramienta para trabajar: ❤️ Relaciones | 🧠 Mentalidad | 💰 Dinero y proyectos | 🙏 Espiritualidad | 🎯 Propósito"
}];
export function Bonuses() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-y border-white/5" data-id="element-88" data-mp="1r8a43hifuvd4">
      <div className="container mx-auto px-6" data-id="element-89" data-mp="3idmytxc3p7g2">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-90" data-mp="3icbu9vatzvnw">
          <div className="inline-flex items-center justify-center gap-2 bg-gold/10 text-gold px-6 py-2 rounded-full mb-6 border border-gold/20" data-id="element-91" data-mp="3n4wmise3a0pb">
            <Gift className="w-5 h-5" data-id="element-92" data-mp="2zhoh8agnurna" />
            <span className="text-sm font-semibold tracking-widest uppercase" data-id="element-93" data-mp="2uh0q7osfmat2">Bonos de la Primera Edición</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-94" data-mp="38hjx2sl5vatn">
          {bonuses.map((bonus, index) => <motion.div key={index} className="bg-ink border border-gold/20 p-8 rounded-2xl relative overflow-hidden group hover:border-gold/50 transition-colors duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-95" data-mp="nq1bz1drb6th" data-mpi={index}>
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-gold/10 to-transparent rounded-bl-full" data-id="element-96" data-mp="3lj32c4x8q7f5"></div>
              
              <span className="text-gold font-serif text-xl italic mb-2 block" data-id="element-97" data-mp="3qhwglzkcq2gd">Bono {bonus.num}</span>
              <h3 className="font-serif text-xl md:text-2xl text-ivory-bright mb-4 leading-snug" data-id="element-98" data-mp="2tu9mi8ar2w63">{bonus.title}</h3>
              <p className="text-muted font-light leading-relaxed" data-id="element-99" data-mp="2xrnujwmp2xwi">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}